<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <v-btn-toggle
      v-model="mode"
      mandatory
      rounded
    >
      <v-btn 
        v-for="tab in tabs"
        :key="tab.value"
        :value="tab.value"
      >
        <v-icon>{{ tab.icon }}</v-icon>
      </v-btn>
    </v-btn-toggle>

    <v-tabs-items
      v-model="mode"
      light
      class="pa-3 d-flex justify-center"
    >
      <v-tab-item
        v-for="tab in tabs"
        :key="tab.value"
        :value="tab.value"
      >
        <component
          :is="tab.componentName"
          :ref="tab.ref"
          :billing-details="billingDetails"
          :items="items"
          :is-ready="isReady"
          :use-client-amount="useClientAmount"
          :coins="crypto"
          :total-amount="totalAmount"
          :mode="mode"
          :currency-icon="currencyIcon"
          :currency="currency"
          v-on="$listeners"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import StripeCardElement from '../stripe/CardElement'
import Crypto from './crypto/Index'

export default {
  components: {
    StripeCardElement,
    Crypto
  },
  props: {
    billingDetails: {
      type: Object,
      default: ()=>{return {}}
    },
    totalAmount: {
      type: Number,
      default: ()=>0
    },
    items: {
      type: Array,
      default: ()=>[]
    },
    isReady: {
      type: Boolean,
    },
    useClientAmount: {
      type: Boolean,
    },
    currencyIcon: {
      type: String,
      default: ()=>null
    },
    currency: {
      type: String,
      default: ()=>null
    }
  },
  data() {
    return {
      mode: 0,
      stripeOption: {
        value: 'credit/debit',
        icon: 'mdi-credit-card-multiple',
        ref: 'stripe',
        componentName: 'StripeCardElement'
      },
      cryptoOption: {
        value: 'crypto',
        icon: 'mdi-currency-btc',
        ref: 'crypto',
        componentName: 'Crypto'
      },
      crypto: []
    }
  },
  computed: {
    tabs() {
      const tabs = [this.stripeOption]
      if (this.crypto && this.crypto.length) {
        tabs.push(this.cryptoOption)
      }
      return tabs 
    }
  },
  watch: {
    mode() {
      this.fetch()      
    }
  },
  mounted(){
    this.fetch()
  },
  methods: {
    async fetch() {
      this.crypto = await this.api.get('/crypto/market/status')
    }
  },

}
</script>